import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ftpipe'
})
export class FtPipe implements PipeTransform {
    transform(input: string|number, freeText: boolean = false): string {
        if (input === null && freeText) {
            return 'Ingyenes';
        }
        if (input === null || input === undefined) {
            input = '0';
        }
        if (typeof input === 'number') {
            input = input.toString();
        }
        return this.ts(input) + ' Ft';
    }
    ts(x: string) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
    
}